import { useCallback, useEffect, useRef } from 'react';
import materialCardImpressionObserver from '../../services/quality-events/material-card-impression.observer';
import { CatalogProps } from '../../utils/enhanced-ecommerce';

// Registers the card's root with the shared impression observer. Attach the returned callback
// ref to the card's root element.
const useMaterialCardImpressionTracking = (item: Material, materialProps: CatalogProps) => {
    const nodeRef = useRef<HTMLElement | null>(null);
    const trackingDataRef = useRef({ item, materialProps });

    const setNodeRef = useCallback((node: HTMLElement | null) => {
        if (nodeRef.current) {
            materialCardImpressionObserver.detach(nodeRef.current);
        }

        nodeRef.current = node;

        if (node) {
            const { item: currentItem, materialProps: currentMaterialProps } = trackingDataRef.current;

            materialCardImpressionObserver.attach(node, currentItem, currentMaterialProps);
        }
    }, []);

    useEffect(() => {
        trackingDataRef.current = { item, materialProps };

        if (nodeRef.current) {
            materialCardImpressionObserver.update(nodeRef.current, item, materialProps);
        }
    }, [item.id, materialProps.internalPath, materialProps.itemIndex]);

    return setNodeRef;
};

export default useMaterialCardImpressionTracking;
